import FileSaver from "file-saver";
import { rebuildQuery } from "../../../utils/url-utils";
import {
  BaseApplicationService,
  SurveyEntity,
  SurveyTabState,
  reportUnexpectedError,
  surveyApiClient,
} from "@graffer-inc/smart-apply";
import { toast } from "react-toastify";
import { Group } from "../../domain/group/group";

export type SurveyContextProps = {
  isSubmitting: boolean;
  tabState: SurveyTabState;
  survey?: SurveyEntity;
  groups: Group[];
  switchTab: typeof SurveyDetailService.prototype.switchTab;
  resetState: typeof SurveyDetailService.prototype.resetState;
  onExportSurvey: typeof SurveyDetailService.prototype.onExportSurvey;
};

export class SurveyDetailService extends BaseApplicationService<SurveyContextProps> {
  state = {
    isSubmitting: false,
    tabState: SurveyTabState.initialize(),
    survey: undefined as SurveyEntity | undefined,
    groups: [],
    switchTab: this.switchTab.bind(this),
    resetState: this.resetState.bind(this),

    onExportSurvey: this.onExportSurvey.bind(this),
  };

  async resetState(
    id: string,
    tab?: string,
    option?: { orgIdFromPath: string }, // URLのパスパラメータから取得したorgIdと手続きのorgIdが一致するかどうかをチェックする
  ) {
    try {
      const { data: survey } = await surveyApiClient.fetchSurvey(id);
      if (option?.orgIdFromPath && survey.orgId !== option.orgIdFromPath) {
        this.setState({
          tabState: SurveyTabState.isValid(tab)
            ? SurveyTabState.from(tab)
            : SurveyTabState.initialize(),
          survey: undefined,
        });
        return;
      }
      this.setState({
        tabState: SurveyTabState.isValid(tab)
          ? SurveyTabState.from(tab)
          : SurveyTabState.initialize(),
        survey: survey,
      });
      await this.getGroups();
    } catch (e) {
      reportUnexpectedError(e);
    }
  }

  async onExportSurvey(id: string) {
    this.setIsSubmitting(true);
    try {
      const { data } = await surveyApiClient.exportSurveySettings(id);
      const blob = new Blob([JSON.stringify(data)], {
        type: "application/json",
      });
      FileSaver.saveAs(blob, `${data.transferSurvey.name}.json`);
      toast.success("アンケートをダウンロードしました。");
    } catch (e) {
      reportUnexpectedError(e);
      toast.error("アンケートのダウンロードに失敗しました。");
    } finally {
      this.setIsSubmitting(false);
    }
  }

  private async getGroups() {
    if (!this.state.survey?.groupIds.length) {
      return;
    }
    try {
      const { data: group } = await surveyApiClient.fetchGroupById(
        this.state.survey.groupIds[0],
      );
      // 複数Groupが所属可能になることを想定し、配列で保持する
      this.setState({
        groups: [group],
      });
    } catch (e) {
      reportUnexpectedError(e);
    }
  }

  switchTab(tabState: SurveyTabState) {
    this.history.push(rebuildQuery({ tab: tabState.getValue() }));
    this.setState({
      tabState: tabState,
    });
  }

  setIsSubmitting(isSubmitting: boolean) {
    this.setState({
      isSubmitting: isSubmitting,
    });
  }
}
